var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Icon from './Icon';
import * as React from 'react';
var isIconPropT = function (icon) {
    return typeof icon === 'object' && typeof icon.icon === 'string';
};
/**
 * A helper component wrapper `Icon`.
 *
 * Used internally to allow passing custom React elements as icons.
 */
export default function IconWrapper(props) {
    return isIconPropT(props) ? (React.createElement(Icon, __assign({}, props))) : (React.createElement("span", { className: props.className }, props.icon));
}
//# sourceMappingURL=IconWrapper.js.map